import React, { Fragment } from "react";

const ComingSoon = ({ title }) => {
  return (
    <Fragment>
      <div className="form-head mb-4">
        <h2 className="text-black font-w600 mb-0">{title}</h2>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body text-center p-5">
              <div className="coming-soon-content">
                <i className="flaticon-381-clock-1 display-1 text-primary mb-4 d-block"></i>
                <h1 className="text-black mb-2">Coming Soon</h1>
                <p className="fs-18">
                  We're working hard to bring you this feature. Stay tuned!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ComingSoon;
